<script lang="ts">
  import type {
    UserCountQueryResponse,
    HistogramResponse,
    PopularResponse,
  } from '../../lib/pandalytics';
  import { createEventDispatcher } from 'svelte';
  import { List, ListItem } from 'svelte-materialify';
  import UsePreviewItem from '../item/UsePreviewItem.svelte';
  import BackgroundImage from '../BackgroundImage.svelte';

  export let popularResponse:
    | PopularResponse
    | HistogramResponse
    | UserCountQueryResponse;
  export let weekly;

  const dispatch = createEventDispatcher();

  async function copyData(data: string) {
    await navigator.clipboard.writeText(data);
  }

  $: list = (popularResponse as PopularResponse).data;
</script>

<div class="list-view">
  <List>
    {#each list as listItem}
      <ListItem
        on:click={async () => {
          if (weekly !== 'Most clicked product urls weekly') dispatch('click', listItem);
        }}
      >
        {#if listItem.item}
          {#if weekly === 'Most clicked product urls weekly'}
            <div class="weekly-item-container">
              <BackgroundImage
                src={listItem.item.image}
                width="50px"
                className="weekly"
              />
              <div class="weekly-info-container">
                <div class="weekly-info">
                  <span on:click={() => copyData(listItem.item.title)}>
                    {listItem.item.title}
                  </span>
                  &nbsp;-&nbsp;
                  <span on:click={() => copyData(listItem.item.url)}> Link </span>
                  &nbsp;-&nbsp;
                  <span on:click={() => copyData(listItem.item.details.description)}>
                    {listItem.item.details.description}
                  </span>
                </div>
                <span>{listItem.item.reportDate}</span>
              </div>
            </div>
          {:else}
            <UsePreviewItem
              id={String(listItem.item.id)}
              category={listItem.item.category}
              project={listItem.item.project}
            >
              {listItem.key}
            </UsePreviewItem>
          {/if}
        {:else}
          {listItem.key}
        {/if}
        <span slot="append">{listItem.doc_count}</span>
      </ListItem>
    {/each}
  </List>
</div>

<style lang="scss">
  .list-view {
    :global(.pi) {
      position: relative;
      overflow: visible;
    }

    :global(.s-list-item),
    :global(.s-list-item__content),
    :global(.s-list-item__title) {
      overflow: visible;
    }
    :global(.pi .pi-inner) {
      background-color: white;
      left: 45%;
      z-index: 2;
    }
    :global(.ri-visual) {
      width: 400px;
    }
    :global(.ri-title) {
      max-width: 400px;
      white-space: normal;
    }
    :global(.link-text.ri-subtitle) {
      display: none;
    }

    .weekly-item-container {
      display: flex;
      .weekly-info-container {
        margin-left: 5px;

        .weekly-info {
          display: flex;

          span:not(span:nth-child(2)) {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 300px;

            &:hover {
              overflow: visible;
            }
          }
          span {
            display: block;

            &:hover {
              color: #3571e7;
              background-color: #dcdcdc;
              border-radius: 3px;
              overflow: visible;
            }
          }
        }
      }
    }
  }
</style>
